import gql from 'graphql-tag';

const mutation = gql`
  mutation SalePaymentProductSave(
    $products: [SaleProductVariantInputType!]!
    $firstSource: String
    $promoCode: String
  ) {
    sale {
      savePaymentProducts(products: $products, firstSource: $firstSource, promoCode: $promoCode) {
        ... on Payment {
          id
          token
          products {
            id
            saleProductVariant {
              id
              name
              saleProduct {
                productCardTitle
              }
            }
            price {
              amount
              currency
            }
          }
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
      }
    }
  }
`;

export default mutation;
